import React from 'react';

const SvgBn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BN_svg__b" fill="#fff">
        <use xlinkHref="#BN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BN_svg__a" />
      <path fill="#F7E250" mask="url(#BN_svg__b)" d="M0 0h28v20H0z" />
      <g mask="url(#BN_svg__b)">
        <path
          fill="#FFF"
          d="M-4.167 3.388l36.334 13.224 1.368-3.758L-2.799-.371z"
        />
        <path
          fill="#262626"
          d="M-5.535 7.146l36.334 13.225 1.368-3.759L-4.167 3.388z"
        />
      </g>
    </g>
  </svg>
);

export default SvgBn;
